import { ReactNode } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useTeam } from "~/contexts/TeamProvider";

import {
  getRequiredOnboardingStep,
  onboardingStepPath,
} from "./onboardingStep";

type Props = {
  children?: ReactNode;
};

/**
 * Keeps pages that live outside SubscriptionRequiredRoute (billing) behind
 * the onboarding steps too. A blocked subscription has no required step, so
 * billing stays open to fix it.
 */
const OnboardingStepRedirect = ({ children }: Props) => {
  const { team } = useTeam();

  // Until the team loads there's no telling whether a step is due.
  if (!team) return null;

  const requiredStep = getRequiredOnboardingStep(team);

  if (requiredStep) {
    return <Navigate to={onboardingStepPath(requiredStep)} replace />;
  }

  return children ?? <Outlet />;
};

export default OnboardingStepRedirect;
